export const selectAdminFileManager = (state) => state.adminfiles;
